import React, { useEffect } from "react"
import { useState } from "react"
import {
  RESULTS_TEXT,
  FINAL_VALUES,
  WHAT_IF_CONSTANTS,
  CALCULATED_RESULTS_KEY,
  RESULTS_KEY,
  WHAT_IF_RESULTS,
  WHAT_IF_EMISSIONS_GRAPH_HEADING_TEXT,
  WHAT_IF_GRAPH_INFO,
  WHAT_IF_GRAPH_INFO_DEFAULT
} from "../../constants"
import {
  Heading2,
  Heading3,
  Heading4,
  Heading5,
  PageContainer,
  PageSection,
  FormGroupWrapper,
  ParagraphText,
   FormTableWrapper,
  TableBody,
  WhatIfTableCell,
  TableHead,
  WhatIfTableHeaderCell,
  WhatIfTableRow,
  Fieldset,
} from "../../UIKit/styles"
import {
  getFieldIsInvalid,
  getSavedFieldValue,
  getValidationMessage,
  getSessionStorageValue,
  setSessionStorage,
  isNullOrUndefined
} from "../../utils/utils"

import {
  FormInput,
  InfoBox,
  SelectInput,
  WhatIfTable,

} from "../../UIKit/components"

import {
  BarGraph,
  ErrorModal,
  LoadingModal,
} from "../../Components"
import { theme } from "../../UIKit"
import { useLocation, useNavigate } from "react-router"
import { WHAT_IF_TITLE, WHAT_IF_SCENARIO_TEXT } from "../../constants"

window.timeout = null;

export default function WhatIf({
    setData,
    data = {},
    sections=[],
    description= "",
    recalculateResults
}) {
  
    const [calculatorData, setCalculatorData] = useState({})
    const [error, setError] = useState(null)
    const [isCalculating, setIsCalculating] = useState(false)

  useEffect(() => {
    const setInitialData = async () => {
      try {
        setIsCalculating(true)
        let originalEmissionsResults = getSessionStorageValue(CALCULATED_RESULTS_KEY);

        if(!originalEmissionsResults) {
          originalEmissionsResults = await getNewCalculationsFigure();
          setSessionStorage(RESULTS_KEY, originalEmissionsResults)
        }
        
        const productiveAreas =  getSavedFieldValueFromVarieties("productiveCanopyArea", data, 0);
        const soilAppliedNitrogenValues = getSavedFieldValueFromVarieties("nitrogenApplied", data, 0);
        const soilAppliedPotassiumValues = getSavedFieldValueFromVarieties("potassiumApplied", data, 0);
        const soilAppliedNitrogenSum = productiveAreas.reduce((acc, curr, index) => {
            return acc + (curr * soilAppliedNitrogenValues[index])  
        }, 0);

        const totalProductiveArea = productiveAreas.reduce((acc, curr) => {
          return acc + curr
        }, 0);

        const soilAppliedPotassiumSum = productiveAreas.reduce((acc, curr, index) => {
            return acc + (curr * soilAppliedPotassiumValues[index])  
        }, 0);

        const compostUsageValues = getSavedFieldValueFromVarieties("greenWasteCompost", data, 0);
        const chickenManureCompostValues = getSavedFieldValueFromVarieties("chickenManureCompost", data, 0);

        const compostUsageSum = compostUsageValues.reduce((acc, curr, index) => {
            const greenwasteVarietySubtotal = (curr * productiveAreas[index]);
            const chickenManureCompostSubTotal = (chickenManureCompostValues[index] * productiveAreas[index]);
            return acc + (greenwasteVarietySubtotal + chickenManureCompostSubTotal);
        }, 0) / totalProductiveArea;

        const combinedMowingSprayingHarvestOtherHours = getSavedFieldValue("calculatorDetails", null, "contractorSprayingHours", data, 0) + getSavedFieldValue("calculatorDetails", null, "contractorMowingHours", data, 0) + getSavedFieldValue("calculatorDetails", null, "contractorHarvestHours", data, 0) + getSavedFieldValue("calculatorDetails", null, "contractorOtherHours", data, 0)

        const yourKgPerHectareInputInitial = (getSavedFieldValue("calculatorDetails", null, "totalKgLeavingOrchard", data, 0) / getSavedFieldValue("calculatorDetails", null, "totalProductiveArea", data, 0)).toLocaleString();

        const class1TraysPerHectareInputInitial = (getSavedFieldValue("calculatorDetails", null, "totalClass1Trays", data, 0) / getSavedFieldValue("calculatorDetails", null, "totalProductiveArea", data, 0));

        const whatIfData = {
            whatif: {
              amountOfSoilAppliedInorganicNInput: soilAppliedNitrogenSum,
              soilAppliedProduct1: "CAN",
              soilAppliedProduct2: "CAN",
              differenceInSoilAppliedProduct: 0,
                currentValues: {
                  yourDieselUseInput: calculateDieselUse(), 
                  contractorShelterBeltTrimmingHoursInput: getSavedFieldValue("calculatorDetails", null, "contractorShelterBeltTrimmingHours", data, 0),
                  contractorMulchingHoursInput:getSavedFieldValue("calculatorDetails", null, "contractorMulchingHours", data, 0),
                  contractorMowingSprayingOtherHoursInput:combinedMowingSprayingHarvestOtherHours,
                  contractorHelicopterHoursInput:getSavedFieldValue("calculatorDetails", null, "contractorHelicopterHours", data, 0), 
                  electricityUsedInput:getSavedFieldValue("calculatorDetails", null, "electricityUsed", data, 0), 
                  soilAppliedInorganicNitrogenNonUreaAverageInput:soilAppliedNitrogenSum /totalProductiveArea,
                  soilAppliedPotassiumInput:soilAppliedPotassiumSum / totalProductiveArea,
                  compostAverageInput:compostUsageSum,
                  yourKgPerHectareInput:yourKgPerHectareInputInitial,
                  class1TraysPerHectareInput:class1TraysPerHectareInputInitial,
                  nitrogenManufacturingEmissions1: calculateNitrogenManufacturingEmissions("CAN"),
                  nitrogenManufacturingEmissions2: calculateNitrogenManufacturingEmissions("CAN"),
                  totalOrchardEmissions1: calculateTotalOrchardNitrogenEmissions("CAN"),
                  totalOrchardEmissions2: calculateTotalOrchardNitrogenEmissions("CAN")
                },
                newValues: {
                  yourDieselUseInput: null,
                  contractorShelterBeltTrimmingHoursInput:null,
                  contractorMulchingHoursInput:null,
                  contractorMowingSprayingOtherHoursInput:null,
                  contractorHelicopterHoursInput:null,
                  electricityUsedInput:null,
                  soilAppliedInorganicNitrogenNonUreaAverageInput:null,
                  soilAppliedPotassiumInput:null,
                  compostAverageInput:null,
                  yourKgPerHectareInput:null,
                  class1TraysPerHectareInput:null,
                  nitrogenManufacturingEmissions1: calculateNitrogenManufacturingEmissions("CAN"),
                  nitrogenManufacturingEmissions2: calculateNitrogenManufacturingEmissions("CAN"),
                  totalOrchardEmissions1: calculateTotalOrchardNitrogenEmissions("CAN"),
                  totalOrchardEmissions2: calculateTotalOrchardNitrogenEmissions("CAN")
                },
                changeToTotals: {
                  yourDieselUseInput: 0,
                  contractorShelterBeltTrimmingHoursInput:0, 
                  contractorMulchingHoursInput:0,
                  contractorMowingSprayingOtherHoursInput:0, 
                  contractorHelicopterHoursInput:0,
                  electricityUsedInput:0,
                  soilAppliedInorganicNitrogenNonUreaAverageInput:0,
                  soilAppliedPotassiumInput:0, 
                  compostAverageInput: 0,
                  yourKgPerHectareInput:0,
                  class1TraysPerHectareInput:0,
                  nitrogenManufacturingEmissions1: 0,
                  nitrogenManufacturingEmissions2: 0,
                  totalOrchardEmissions1: 0,
                  totalOrchardEmissions2: 0
                },
            }
          }

        setCalculatorData(whatIfData)       


        } catch (e) {
          setError(e.message)
      } finally {
        setIsCalculating(false)
        setError(null)
      }
    }
    
    setInitialData()
    return () => {
      setInitialData(null)
    }
  }, [])

  const calculateNitrogenManufacturingEmissionsDifference = () => {
    const E46 = calculateNitrogenManufacturingEmissions(getSavedFieldValue("whatif", null, "soilAppliedProduct1", calculatorData, 0))
    const E48 = calculateNitrogenManufacturingEmissions(getSavedFieldValue("whatif", null, "soilAppliedProduct2", calculatorData, 0))

    if(isNullOrUndefined(E46) || isNullOrUndefined(E48) || E46 === 0) return 0;
    return ((E48/E46 -1)*100);
  };

  const calculateTotalOrchardNitrogenEmissionsDifference = () => {
    const E46 = calculateTotalOrchardNitrogenEmissions(getSavedFieldValue("whatif", null, "soilAppliedProduct1", calculatorData, 0))
    const E48 = calculateTotalOrchardNitrogenEmissions(getSavedFieldValue("whatif", null, "soilAppliedProduct2", calculatorData, 0))

    if(isNullOrUndefined(E46) || isNullOrUndefined(E48) || E46 === 0) return 0;
    return ((E48/E46 -1)*100);
  };


  
  const calculateNitrogenManufacturingEmissions = (product) => {

    const soilAppliedNitrogenValues = getSavedFieldValueFromVarieties("nitrogenApplied", data, 0);
    const C46 = getProductValue(product);
    const C41 = getSavedFieldValue("whatif", "currentValues", "soilAppliedInorganicNitrogenNonUreaAverageInput", calculatorData);

    const totalProductiveArea = getSavedFieldValueFromVarieties("productiveCanopyArea", data, 0).reduce((acc, curr) => {  
      return acc + curr
      }, 0);

    return ((C46 * C41) * totalProductiveArea);

  }

  const calculateTotalOrchardNitrogenEmissions = (product) => {
  const originalEmissionsResults = getSessionStorageValue(CALCULATED_RESULTS_KEY);

  if(isNullOrUndefined(originalEmissionsResults)) return 0;

const C_E51 = originalEmissionsResults.fieldEmissions.fieldEmissionsUseSubTotal
const C_E41 = originalEmissionsResults.capitalUse.capitalUseSubTotal
const C_E29 = originalEmissionsResults.indirectUse.indirectUseSubTotal
const C_E13 = originalEmissionsResults.directEnergyUse.directEnergySubtotal
const C_E60 = originalEmissionsResults. inorganicWaste.inorganicWasteSubTotal


    const C_E62 = C_E51+C_E41+C_E29+C_E13+C_E60;
    const RESULT_C21 = C_E62;
    const C_E16 = originalEmissionsResults.indirectUse.nitrogenNonUrea;
    const C46 = getProductValue(product) 
    const C23 = getSavedFieldValue("whatif", "currentValues", "soilAppliedInorganicNitrogenNonUreaAverageInput", calculatorData);
    const C41 = C23;

    const PROD_C24 =  getSavedFieldValueFromVarieties("productiveCanopyArea", data, 0).reduce((acc, curr) => {
        return acc + curr
    }, 0);

    return ((RESULT_C21 - C_E16) + (C46 * C41 * PROD_C24));
  }

  const calculateDieselUse = () => {

      if(getSavedFieldValue("calculatorDetails", null, "knowFuelUse", data, 0)) {

        return getSavedFieldValue("calculatorDetails", null, "dieselUsed", data) 
      } else {
         const {machineryFuelConsumption: {
        mulching,
        mowing,
        spraying,
        harvest,
        other,
    }} = WHAT_IF_CONSTANTS;

        const sprayingUsage = getSavedFieldValue("calculatorDetails", null, "selfSprayingHours", data, 0) * spraying;
        const mowingUsage = getSavedFieldValue("calculatorDetails", null, "selfMowingHours", data,0) * mowing;
        const mulchingUsage = getSavedFieldValue("calculatorDetails", null, "selfMulchingHours", data,0) * mulching;
        const otherUsage = getSavedFieldValue("calculatorDetails", null, "selfOtherHours", data,0) * other;
        const harvestUsage = getSavedFieldValue("calculatorDetails", null, "selfHarvestHours", data,0) * harvest;
        return sprayingUsage + mowingUsage + mulchingUsage + otherUsage + harvestUsage;
    }
  }

  const calculateTotalEmissions = () => {

    const originalEmissionsResults = getSessionStorageValue(CALCULATED_RESULTS_KEY);
    const { inorganicWaste: { inorganicWasteSubTotal }, directEnergyUse: {directEnergySubtotal }, indirectUse: { indirectUseSubTotal }, fieldEmissions: { fieldEmissionsUseSubTotal}, capitalUse: { capitalUseSubTotal}} = originalEmissionsResults;


    const E51 = fieldEmissionsUseSubTotal;
    const E41 =capitalUseSubTotal;
    const E29= indirectUseSubTotal
    const E13=directEnergySubtotal;
    const E60= inorganicWasteSubTotal;

    const C_E62 = E51+E41+E29+E13+E60;
    const R_C21 = C_E62;
    const J23 = R_C21;

    return J23;

  }

  const calculateEmissionsField = async (field) => {
    let result = 0;
    let originalEmissions = 0;
    const originalValue = getSavedFieldValue("whatif", "currentValues", field, calculatorData);
    let inputValue = getSavedFieldValue("whatif", "newValues", field, calculatorData);
    if(inputValue === "") inputValue = originalValue;

    const originalEmissionsResults = getSessionStorageValue(CALCULATED_RESULTS_KEY);
    const { indirectUse, directEnergyUse, fieldEmissions, results } = originalEmissionsResults;
    
    const J23 = calculateTotalEmissions();

  
    switch(field) {
      case "yourDieselUseInput": {
        const E14 = inputValue;
        const { dieselLifeCycle: C_K3 } = WHAT_IF_CONSTANTS;
        const D7 =  C_K3;
        const C7 = calculateDieselUse()
        const { dieselEmission: C_C7 } = directEnergyUse;
        const C_C6 = D7*C7;

        let J14 = getSavedFieldValue("calculatorDetails", null, "knowFuelUse", data) ? C_C7 : C_C6;
        let K14 = isNullOrUndefined(E14) || E14 === 0  ? 0 : (E14 * C_K3);

        result = ((J23-J14+K14)/J23)-1
           
        break;
      }

      
      case "contractorShelterBeltTrimmingHoursInput": {

        if(isNullOrUndefined(inputValue)) return 0;
        const { contractorShelterBeltTrimmingEmissions: C_C16 } = directEnergyUse;
        const { directEnergyUse: { contractorShelterBeltTrimmingEmissions: recalculatedContractorShelterBeltTrimmingEmissions} } = await getNewCalculationsFigure("calculatorDetails", null, "contractorShelterBeltTrimmingHours", inputValue);
      
        result = ((J23-C_C16+recalculatedContractorShelterBeltTrimmingEmissions)/J23)-1;      
        break;
      }

      case "contractorMulchingHoursInput": {

        if(isNullOrUndefined(inputValue)) return 0;
        const { contractorMulchingEmissions: C_C17 } = directEnergyUse;
        const { directEnergyUse: { contractorMulchingEmissions: recalculatedContractorMulchingEmissions} } = await getNewCalculationsFigure("calculatorDetails", null, "contractorMulchingHours", inputValue);
      
        result = ((J23-C_C17+recalculatedContractorMulchingEmissions)/J23)-1;     
        break;
      }
      
      case "contractorMowingSprayingOtherHoursInput": {
        if(isNullOrUndefined(inputValue)) return 0;
        

        const { contractorSprayingEmissions: C_C15,
        contractorMowingEmissions: C_C21,
        contractorHarvestEmissions: C_C23,
        contractorOtherEmissions: C_C27      
        } = directEnergyUse;

        const C18 = C_C15 + C_C21 + C_C23 + C_C27;

        const { directEnergyUse: { 
          contractorSprayingEmissions:recalculatedContractorSprayingEmissions,
          contractorMowingEmissions:recalculatedContractorMowingEmissions,
          contractorHarvestEmissions:recalculatedContractorHarvestEmissions,
          contractorOtherEmissions: recalculatedContractorOtherEmissions
        } } = await getNewCalculationsFigure("calculatorDetails", null, ["contractorSprayingHours","contractorMowingHours","contractorHarvestHours","contractorOtherHours"], [0,0,0,inputValue]);

        const E18 = recalculatedContractorSprayingEmissions + recalculatedContractorMowingEmissions + recalculatedContractorHarvestEmissions + recalculatedContractorOtherEmissions;

        result = ((J23-C18+E18)/J23)-1
        break;
      }
      case "contractorHelicopterHoursInput": {
        if(isNullOrUndefined(inputValue)) return 0;

        const { contractorAviationEmissions: C_C19 } = directEnergyUse;
        const { directEnergyUse: { contractorAviationEmissions: recalculatedContractorAviationEmissions} } = await getNewCalculationsFigure("calculatorDetails", null, "contractorHelicopterHours", inputValue);
      
        result = ((J23-C_C19+recalculatedContractorAviationEmissions)/J23)-1;      
        break;
      }
      case "electricityUsedInput": {
        const { electricityEmissions: J19 }  = directEnergyUse;
        const E21 = inputValue;
        const { results: { total: { electricityEmissions: recalculatedElectrictyEmissions}} } = await getNewCalculationsFigure("calculatorDetails", null, "electricityUsed", inputValue);
        const K19 =  isNullOrUndefined(E21) ? J19 : recalculatedElectrictyEmissions;

        result =(J23-J19+K19)/J23-1;
        break;
      }
      case "soilAppliedInorganicNitrogenNonUreaAverageInput": {
        const { nitrogenNonUrea:C_E16,  } = indirectUse;
        const { nitrousOxideNonUrea:C_E44 } =  fieldEmissions;

        const E23 = inputValue;
        const C23 = originalValue;
        const J20 = C_E16 + C_E44;

        const K20 =  isNullOrUndefined(E23) ? J20 : ((E23/C23)*J20);

        result = C23 === 0 ? 0 :  (J23-J20+K20)/J23-1;
        break;
      }
      case "soilAppliedPotassiumInput": {
        const { potassium:J21 } = indirectUse;
        const E24 = inputValue;
        const C24 = originalValue;
        const K21 = (isNullOrUndefined(E24)) ?  J21 : ((E24/C24-1)*J21)+J21;

        result = C24 === 0 ? 0 : (J23-J21+K21)/J23-1;
        break;
      }
      case "compostAverageInput" :{
        
        if(isNullOrUndefined(inputValue) || inputValue === originalValue) return 0;

        const C25 = originalValue;

        const { compostEmissionsFactor, nitrousOxideEmissionsPotential }= WHAT_IF_CONSTANTS;

        const CONST_B130 = compostEmissionsFactor //compostEmissionsFactor
        const CONST_B131 = (0.5*0.01)+0.5*CONST_B130; //chickenEmisionsFactor;
        const averageCompostEmissions = (CONST_B130 + CONST_B131) / 2;

        const CONST_F10 = nitrousOxideEmissionsPotential;
        const CONST_B10 = CONST_F10;
        const CONST_B20 = 0.01; 
        const CONST_C130 = CONST_B20*(44/28)*CONST_B10
        
        const productiveAreas =  getSavedFieldValueFromVarieties("productiveCanopyArea", data, 0);
        const totalProductiveArea = productiveAreas.reduce((acc, curr) => {
          return acc + curr
        }, 0);

        const COMPOST_C21 = getSavedFieldValue("varieties", "green", "compostDryMatter", data, 0) 
        const CONST_B141 = COMPOST_C21;
        const COMPOST_C20 = getSavedFieldValue("varieties", "green", "compostNitrogenPercent", data, 0) 
        const CONST_B140 = COMPOST_C20*CONST_B141;

        const COMPOST_C15 = originalValue > 0 ? ( getSavedFieldValue("varieties", "green", "greenWasteCompost", data, 0)  ):  (inputValue /2);
        const CONST_B143 = COMPOST_C15*1000

        const COMPOST_D20 = getSavedFieldValue("varieties", "gold", "compostNitrogenPercent", data, 0) 

        const COMPOST_I20 = getSavedFieldValue("varieties", "green", "manureNitrogenPercent", data, 0) 
        const COMPOST_I21 = getSavedFieldValue("varieties", "green", "manureDryMatter", data, 0) 
        const CONST_B146 = COMPOST_I21;
        const CONST_B145 = COMPOST_I20*CONST_B146;

        const COMPOST_I15 =  originalValue > 0 ? ( getSavedFieldValue("varieties", "green", "chickenManureCompost", data, 0)  ):  (inputValue /2);

        const CONST_B148 = COMPOST_I15*1000;

        const PROD_C20 = getSavedFieldValue("varieties", "green", "productiveCanopyArea", data, 0); 
        const PROD_C21 = getSavedFieldValue("varieties", "gold", "productiveCanopyArea", data, 0);
        const PROD_C22 = getSavedFieldValue("varieties", "other", "productiveCanopyArea", data, 0);

        const COMPOST_D21 =  getSavedFieldValue("varieties", "gold", "compostDryMatter", data, 0);
        const CONST_C141 = COMPOST_D21;
        const CONST_C140 = COMPOST_D20*CONST_C141;

        const COMPOST_D15 =  getSavedFieldValue("varieties", "gold", "greenWasteCompost", data, 0); 
        const CONST_C143 = COMPOST_D15*1000;

        const COMPOST_J21 = getSavedFieldValue("varieties", "gold", "manureDryMatter", data, 0) 
        const COMPOST_J20 =  getSavedFieldValue("varieties", "gold", "manureNitrogenPercent", data, 0) 
        const CONST_C146 = COMPOST_J21
        const CONST_C145 = COMPOST_J20*CONST_C146;

        const COMPOST_J15 =  getSavedFieldValue("varieties", "gold", "chickenManureCompost", data, 0); 
        const CONST_C148 = COMPOST_J15*1000

        const COMPOST_E20 = getSavedFieldValue("varieties", "other", "compostNitrogenPercent", data, 0); 
        const COMPOST_E21 =  getSavedFieldValue("varieties", "other", "compostDryMatter", data, 0);
        const CONST_D141 = COMPOST_E21; 
        const CONST_D140 =COMPOST_E20*CONST_D141;

        const COMPOST_E15 = getSavedFieldValue("varieties", "other", "greenWasteCompost", data, 0); 
        const CONST_D143 = COMPOST_E15*1000;

        const COMPOST_K20 =  getSavedFieldValue("varieties", "other", "manureNitrogenPercent", data, 0); 
        const COMPOST_K21 =  getSavedFieldValue("varieties", "other", "manureDryMatter", data, 0); 
        const CONST_D146 = COMPOST_K21;
        const CONST_D145 = COMPOST_K20*CONST_D146;

        const COMPOST_K15 = getSavedFieldValue("varieties", "other", "chickenManureCompost", data, 0); 
        const CONST_D148 = COMPOST_K15*1000

        let C_C47 = 0;
        
        if(C25 > 0) {
          C_C47 = 
          (CONST_B140*CONST_B143*PROD_C20)+
          (CONST_B145*CONST_B148*PROD_C20)+
          (CONST_C140*CONST_C143*PROD_C21)+
          (CONST_C145*CONST_C148*PROD_C21)+
          (CONST_D140*CONST_D143*PROD_C22)+
          (CONST_D145*CONST_D148*PROD_C22)

        } else { 

        C_C47 = (CONST_B140 * CONST_B143 * totalProductiveArea) + (CONST_B145*CONST_B148*totalProductiveArea);
        }

        const C_D47 = CONST_C130;
        const C_E47 = C_C47 * C_D47;
        
        const { compost: C_E23, manure: C_E24 } =  indirectUse;
        const J25 = C_E23 + C_E24;
        const J26 = C_E47;
        const E25 = inputValue;
        const K25 =  C25 > 0 ? ((E25/C25)*J25) : (totalProductiveArea * E25) * averageCompostEmissions * 1000;
        const K26 = C25 > 0 ? ((E25/C25)*J26) : C_E47;
        const J27 = J25 + J26;
        const K27 = K25 + K26;
        result = (J23-J27+K27)/J23-1;
        break;
      }
      case "yourKgPerHectareInput" :{
        if(isNullOrUndefined(inputValue)) return 0;

        const E32 = inputValue;
        const productiveAreas =  getSavedFieldValueFromVarieties("productiveCanopyArea", data, 0);
        const P_C24 = productiveAreas.reduce((acc, curr) => {
          return acc + curr
        }, 0);

        const { total, totalPerKg } = results;

        const fieldsToSum = ["nitrogenManufacturingEmissions", "nitrogenManufacturingEmissions", "fuelEmissions", "fertiliserSoilEmissions", "nitrogenPercentageOfEmissions", "fertiliserManufactureEmissions", "wasteRecyclingEmissions", "compostSoilEmissions", "nitrogenFieldEmissions", "capitalEmissions", "agrichemicalsEmissions", "electricityEmissions", "pruningSoilEmissions", "compostManufactureEmissions"];

        const C_E62 = fieldsToSum.reduce((acc, field) => {
          return acc + total[field];
        }, 0);

        const C_I62 = fieldsToSum.reduce((acc, field) => {
          return acc + totalPerKg[field];
          }, 0);
            
        result = C_E62/ (E32*P_C24)/(C_I62/1000)-1
        break;
      }
      case "class1TraysPerHectareInput" :{
        if(isNullOrUndefined(inputValue)) return 0;
        const E33= inputValue;
        const productiveAreas =  getSavedFieldValueFromVarieties("productiveCanopyArea", data, 0);
        const P_C24 = productiveAreas.reduce((acc, curr) => {
          return acc + curr
        }, 0);

        
        const { total, totalPerTray } = results;

        const fieldsToSum = ["nitrogenManufacturingEmissions", "nitrogenManufacturingEmissions", "fuelEmissions", "fertiliserSoilEmissions", "nitrogenPercentageOfEmissions", "fertiliserManufactureEmissions", "wasteRecyclingEmissions", "compostSoilEmissions", "nitrogenFieldEmissions", "capitalEmissions", "agrichemicalsEmissions", "electricityEmissions", "pruningSoilEmissions", "compostManufactureEmissions"];

        const C_E62 = fieldsToSum.reduce((acc, field) => {
          return acc + total[field];
        }, 0);

        const C_L62 = fieldsToSum.reduce((acc, field) => {
          return acc + totalPerTray[field];
          }, 0);
            
        result = C_E62/ (E33*P_C24)/(C_L62/1000)-1
        break;
      }
      default: {
        result = 0;    
      }
    }
    
    result = (result * 100).toFixed(2)+"%";

    let updatedData = {
      ...data,
      ...calculatorData
    };


    updatedData.whatif.changeToTotals[field] = result ? result : 0;
    setCalculatorData(updatedData)

  }


  const getSavedFieldValueFromVarieties = (field, data, initialValue) => {
    const section = "varieties";
    const subsections = ["green", "gold", "other"];

    return subsections.map((subsection) => {
        return getSavedFieldValue(section, subsection, field, data, initialValue);
    })
  }
  
  const getTitle = () => {
    const orchardName = getSavedFieldValue(
      "calculatorDetails",
      null,
      "orchardName",
      data
    )
    if (!orchardName) return RESULTS_TEXT
    return `${WHAT_IF_SCENARIO_TEXT}`
  }
//shift to utils
    const getUpdatedDataForSection = (sectionData, subsection, field, value) => {
    if (subsection) {
      sectionData[subsection] = {
        ...(sectionData[subsection] || {}),
        [field]: value,
      }
    } else {
      sectionData[field] = value
    }
    return sectionData
  }

  const getFieldInput = ({
    field,
    section,
    subsection,
    type = "text",
    options,
    rows,
    columns,
    title,
    message,
    helpText,
    initialValue,
    ...otherProps
  }) => {
    const value = getSavedFieldValue(section, subsection, field, calculatorData)


 switch (type) {
      case "table": {
        return (
          <WhatIfTable
            value={value}
            {...otherProps}
            key={`table-${otherProps.label || title}`}
            label={otherProps.label}
            id={otherProps.label || title}
            columns={columns}
            rows={getRows(columns, rows, section, calculatorData)}
            onChange={(field, subsection, value) =>
              handleOnChangeValue(value, field, section, subsection)
            }
            footers={title === "Change inputs" ? getFooter(calculatorData): null}
          />
        )
      }
      case "select": {
        return (
          <SelectInput
            key={`${section}-${field}-${subsection}`}
            {...otherProps}
            id={field}
            options={options}
            onChange={(value) =>
              handleOnChangeValue(value, field, section, subsection)
            }
            value={value}
            aria-invalid={getFieldIsInvalid(value, type, {...otherProps})}
            helpText={helpText}
            validationText={getValidationMessage(value, type, {...otherProps})}
          />
        )
      }
      case "message": {
        return (
          <p
            key={`${section}-${field}-${subsection}`}
            id={field}
            dangerouslySetInnerHTML={{ __html: message }}
          />
        );
      }
      default: {
        return (
          <FormInput
            key={`${section}-${field}-${subsection}`}
            {...otherProps}
            type={type}
            id={field}
            onChange={(value) =>
              handleOnChangeValue(value, field, section, subsection)
            }
            value={value}
            aria-invalid={getFieldIsInvalid(value, type, {...otherProps})}
            helpText={helpText}
            validationText={getValidationMessage(value, type, {...otherProps})}
          />
        )
      }
    }




  }

  const getFooter = (calculatorData) => {
    if(!calculatorData || isNullOrUndefined(calculatorData?.whatif?.changeToTotals)) return ["","","Total", "0%"];

    const sumOfChange = calculateSumOfChange(calculatorData);
    
    return ["","","Total", `${sumOfChange.toFixed(2)}%`]
  };

  const calculateSumOfChange = (calculatorData) => {
        if(!calculatorData || isNullOrUndefined(calculatorData?.whatif?.changeToTotals)) return 0;

    const { whatif: {changeToTotals: {
              yourDieselUseInput,
              contractorShelterBeltTrimmingHoursInput, 
              contractorMulchingHoursInput,
              contractorMowingSprayingOtherHoursInput, 
              contractorHelicopterHoursInput,
              electricityUsedInput,
              soilAppliedInorganicNitrogenNonUreaAverageInput,
              soilAppliedPotassiumInput, 
              compostAverageInput
          }}} = calculatorData;

    const sumOfChange = [ yourDieselUseInput,
              contractorShelterBeltTrimmingHoursInput, 
              contractorMulchingHoursInput,
              contractorMowingSprayingOtherHoursInput, 
              contractorHelicopterHoursInput,
              electricityUsedInput,
              soilAppliedInorganicNitrogenNonUreaAverageInput,
              soilAppliedPotassiumInput, 
              compostAverageInput].reduce((a, c) => {
                let value = c;
                if(c === 0) return a + 0;
                value = value.includes("%") ? value.replace("%", "") : value;
                value= parseFloat(value);
                return a + value;
              }, 0)   
    return sumOfChange;
  }


  const getRows = (columns, rows, section, dataSource) => {
    return rows.map((row) => {

    return {
      ...row,
      values: columns.reduce((result, column) => {
        return {
          ...result,
          [column.subsection]: getSavedFieldValue(
            section,
            column.subsection,
            row.field,
            dataSource
          ),
        }
      }, {})
    }
    })
  }

  const handleOnChangeValue = (value, field, sectionName, subsection) => {
    const sectionData = calculatorData[sectionName] || {}
    let updatedData = {
      ...data,
      [sectionName]: getUpdatedDataForSection(
        sectionData,
        subsection,
        field,
        value
      ),
    }
    setCalculatorData(updatedData)

    if (window.timeout ) clearTimeout(window.timeout );
      window.timeout  = setTimeout(
        async () => {
          calculateEmissionsField(field)
        },
        400
      );

  }

  const getNewCalculationsFigure = async (section = "calculatorDetails", subsection, field, value) => { 
    
      try {
        setIsCalculating(true)
        const { calculatorDetails, varieties } = data
        const varietyNames = Object.keys(FINAL_VALUES.varieties)

        const calculatorBody = {
          calculatorDetails: {
            ...FINAL_VALUES.calculatorDetails,
            ...Object.keys(calculatorDetails).reduce((result, key) => {
              let value = calculatorDetails[key];
              if (key.toLowerCase().includes("percentage") && value)
                value = value / 100;
              if (value === "") {
                value = 0;
              }
              return {
                ...result,
                [key]: value,
              };
            }, {}),
            totalArea: calculatorDetails.totalProductiveArea || 0,
          },
          varieties: varietyNames.reduce((result, varietyName) => {
            return {
              ...result,
              [varietyName]: {
                ...FINAL_VALUES.varieties[varietyName],
                ...Object.keys(varieties[varietyName] || {}).reduce(
                  (varietyResult, key) => {
                    let value = varieties[varietyName][key];
                    if (key.toLowerCase().includes("percentage") && value)
                      value = value / 100;
                    if (value === "") value = 0;
                    return {
                      ...varietyResult,
                      [key]: value,
                    };
                  },
                  {}
                ),
                //BACKEND expect these values to be at the variety level not calculatorDetails level.
                compostNitrogenPercent:
                  calculatorDetails.compostNitrogenPercent / 100,
                compostDryMatter: calculatorDetails.compostDryMatter / 100,
                manureNitrogenPercent:
                  calculatorDetails.manureNitrogenPercent / 100,
                manureDryMatter: calculatorDetails.manureDryMatter / 100,
              },
            };
          }, {}),
        };

            if(field) {
            if(Array.isArray(field)) {
              field.forEach((fieldName, index) => {
                if(Array.isArray(value)) {
                  calculatorBody[section][fieldName] = value[index];
                } else {
                calculatorBody[section][fieldName] = value;
                }
              })
            } else {
              calculatorBody[section][field] = value;
            }
          }
            
          const response = await fetch(
            `${process.env.REACT_APP_CALC_API_URL}/kpins/${calculatorDetails.kpin}?saveData=false`,
          {
            headers: {
              "Content-Type": "application/json",
            },
            method: "POST",
            body: JSON.stringify(calculatorBody),
          }
        )
        const result = await response.json()
        if (result.error) throw new Error(result.error)

        return result;


      } catch (e) {
        setError(e.message)
      } finally {
        setIsCalculating(false)
      }
    }
  
  const getProductValue = (product) => {
    return WHAT_IF_CONSTANTS[product];
  }

  const getGraphData = () => {
    if(!calculatorData || isNullOrUndefined(calculatorData?.whatif?.changeToTotals)) return WHAT_IF_GRAPH_INFO_DEFAULT;


    const originalEmissionsResults = getSessionStorageValue(CALCULATED_RESULTS_KEY);
    const { directEnergyUse: { electricityEmissions, contractorAviationEmissions, contractorMulchingEmissions,contractorShelterBeltTrimmingEmissions, contractorSprayingEmissions, contractorHarvestEmissions, contractorMowingEmissions, contractorOtherEmissions, dieselEmission  }, indirectUse : { compost, manure, potassium, nitrogenNonUrea,  }, fieldEmissions: { nitrousOxideNonUrea, nitrousOxideCompost }  } = originalEmissionsResults;

    const emissionsSubtotal = calculateTotalEmissions();

    const newEmissionsSubTotal = emissionsSubtotal * (1 + calculateSumOfChange(calculatorData)/100);

    const graphData = [
    [
        {
            "x": "Total",
            "y": emissionsSubtotal
        },
        {
            "x": "Compost",
            "y": compost + manure + nitrousOxideCompost
        },
        {
            "x": "Potassium",
            "y": potassium
        },
        {
            "x":  "Inorganic soil applied N (non-urea)",
            "y": nitrogenNonUrea + nitrousOxideNonUrea
        },
        {
            "x": "Electricity",
            "y": electricityEmissions
        },
        {
            "x":"Contractor helicopter fuel use",
            "y": contractorAviationEmissions
        },
        {
            "x": "Contractor mowing, spraying, other",
            "y": contractorSprayingEmissions + contractorHarvestEmissions + contractorMowingEmissions + contractorOtherEmissions
        },
        {
            "x":  "Contractor mulching",
            "y": contractorMulchingEmissions
        },
        {
            "x": "Contractor shelter belt trimming",
            "y": contractorShelterBeltTrimmingEmissions
        },
        {
            "x": "Diesel use",
            "y": dieselEmission
        },
    ],
    [
        {
            "x": "Total",
            "y": newEmissionsSubTotal  // calculate total
        },
        {
            "x": "Compost",
            "y": calculateGraphEmissions((compost + manure + nitrousOxideCompost), "compostAverageInput")
        },
        {
            "x": "Potassium",
            "y":calculateGraphEmissions(potassium, "soilAppliedPotassiumInput")

        },
        {
            "x":  "Inorganic soil applied N (non-urea)",
            "y": calculateGraphEmissions( ( nitrogenNonUrea + nitrousOxideNonUrea) , "soilAppliedInorganicNitrogenNonUreaAverageInput")
        },
        {
            "x": "Electricity",
            "y": calculateGraphEmissions(electricityEmissions, "electricityUsedInput")
        },
        {
            "x":"Contractor helicopter fuel use",
            "y": calculateGraphEmissions(contractorAviationEmissions, "contractorHelicopterHoursInput")
     
        },
        {
            "x": "Contractor mowing, spraying, other",
            "y":  calculateGraphEmissions( (contractorSprayingEmissions + contractorHarvestEmissions+ contractorMowingEmissions + contractorOtherEmissions ), "contractorMowingSprayingOtherHoursInput")
        },
        {
            "x":  "Contractor mulching",
            "y": calculateGraphEmissions(contractorMulchingEmissions, "contractorMulchingHoursInput")
        },
        {
            "x": "Contractor shelter belt trimming",
            "y": calculateGraphEmissions(contractorShelterBeltTrimmingEmissions, "contractorShelterBeltTrimmingHoursInput")       
        },
        {
            "x": "Diesel use",
            "y": calculateGraphEmissions(dieselEmission, "yourDieselUseInput")
        },
    ],
]
return graphData;
  }

  const calculateGraphEmissions = (emission, field) => {
    const originalFieldValue = calculatorData.whatif.currentValues[field];
    const newFieldValue = !isNullOrUndefined(calculatorData.whatif.newValues[field]) ? calculatorData.whatif.newValues[field] : originalFieldValue;

    return originalFieldValue !== 0 ? emission * (newFieldValue / originalFieldValue) : emission;
  }

  return (
    <PageContainer>
      <Heading2>{getTitle()}</Heading2>
    {description && (
      <PageSection>
        <ParagraphText>{description}</ParagraphText>
      </PageSection>
    )}
    {sections.map((section) => (
      <PageSection key={section.title}>
        <Heading3>{section.title}</Heading3>
        <Heading4>{section.subTitle}</Heading4>
        {section.info && (
          <InfoBox>
            <ParagraphText>{section.info}</ParagraphText>
          </InfoBox>
        )}
        <FormGroupWrapper>
          {section.inputFields.map((inputField) =>
            getFieldInput({ ...inputField, title: section.title })
          )}
        </FormGroupWrapper>
      </PageSection>
    ))}

     {!isCalculating && ( <PageSection key={"Soil Applied inorganic nitrogen - Manufacturing emissions"}>
      <Heading3>Soil Applied inorganic nitrogen - Manufacturing emissions</Heading3>

      <InfoBox>
        <ParagraphText>The following allows you to compare the impact of using different nitrogen fertilisers. Emissions factors only available for CAN, DAP, SOA and urea. The urea value is an average for imported and NZ made product; for confidentiality reasons values were not available for imported vs NZ urea.</ParagraphText>
      </InfoBox>

      <FormGroupWrapper> 
        <ParagraphText>Amount of soil applied inorganic N applied; non-urea (kg N/ha)</ParagraphText>
        <ParagraphText><strong>{ getSavedFieldValue("whatif", "currentValues", "soilAppliedInorganicNitrogenNonUreaAverageInput", calculatorData) !== "" ? getSavedFieldValue("whatif", "currentValues", "soilAppliedInorganicNitrogenNonUreaAverageInput", calculatorData).toFixed(): ""}</strong></ParagraphText>

        <Fieldset>
          <FormTableWrapper>
            <TableHead highlightHeader={true}>
              <WhatIfTableRow>
                  <WhatIfTableHeaderCell>
                    Select Product below to compare
                  </WhatIfTableHeaderCell>
                  <WhatIfTableHeaderCell>
                    Emissions factor (kg CO2e/kg N)
                  </WhatIfTableHeaderCell>
                  <WhatIfTableHeaderCell>
                  Nitrogen manufacturing emissions (kg CO2e)
                  </WhatIfTableHeaderCell>
                  <WhatIfTableHeaderCell>
                    Total orchard emissions (kg CO2e)
                  </WhatIfTableHeaderCell>

              </WhatIfTableRow>
            </TableHead>
              <TableBody>
                <WhatIfTableRow>
                  <WhatIfTableCell>
                    <SelectInput
                      id={"soilAppliedProduct1"}
                      options={[{
                    value: "DAP",
                    label: "DAP",
                  },
                  {
                    value: "SOA",
                    label: "SOA",
                  },
                  {
                    value: "CAN",
                    label: "CAN",
                  },
                  {
                    value: "OTHER",
                    label: "Other",
                  },]}
                      onChange={(value) =>
                        handleOnChangeValue(value, "soilAppliedProduct1", "whatif", null)
                      }
                      value={getSavedFieldValue("whatif", null, "soilAppliedProduct1", calculatorData, 0)}
                    />
                  </WhatIfTableCell>
                  <WhatIfTableCell  alignment={"center"}>{getProductValue(getSavedFieldValue("whatif", null, "soilAppliedProduct1", calculatorData, 0))}</WhatIfTableCell>
                  <WhatIfTableCell alignment={"center"}>{calculateNitrogenManufacturingEmissions(getSavedFieldValue("whatif", null, "soilAppliedProduct1", calculatorData, 0)).toLocaleString()}</WhatIfTableCell>
                  <WhatIfTableCell alignment={"center"}>{calculateTotalOrchardNitrogenEmissions(getSavedFieldValue("whatif", null, "soilAppliedProduct1", calculatorData, 0)).toLocaleString()}</WhatIfTableCell>
                </WhatIfTableRow>
                <WhatIfTableRow>
                  <WhatIfTableCell>vs</WhatIfTableCell>
                  <WhatIfTableCell></WhatIfTableCell>
                  <WhatIfTableCell></WhatIfTableCell>
                  <WhatIfTableCell></WhatIfTableCell>
                </WhatIfTableRow>
                <WhatIfTableRow>
                  <WhatIfTableCell>
                    <SelectInput
                      id={"soilAppliedProduct2"}
                      options={[{
                    value: "DAP",
                    label: "DAP",
                  },
                  {
                    value: "SOA",
                    label: "SOA",
                  },
                  {
                    value: "CAN",
                    label: "CAN",
                  },
                  {
                    value: "OTHER",
                    label: "Other",
                  },]}
                      onChange={(value) =>
                        handleOnChangeValue(value, "soilAppliedProduct2", "whatif", null)
                      }
                      value={getSavedFieldValue("whatif", null, "soilAppliedProduct2", calculatorData, 0)}
                    />
                  </WhatIfTableCell>
                  <WhatIfTableCell alignment={"center"}>{getProductValue(getSavedFieldValue("whatif", null, "soilAppliedProduct2", calculatorData, 0))}</WhatIfTableCell>
                  <WhatIfTableCell alignment={"center"}>{calculateNitrogenManufacturingEmissions(getSavedFieldValue("whatif", null, "soilAppliedProduct2", calculatorData, 0)).toLocaleString()}</WhatIfTableCell>
                  <WhatIfTableCell alignment={"center"}>{calculateTotalOrchardNitrogenEmissions(getSavedFieldValue("whatif", null, "soilAppliedProduct2", calculatorData, 0)).toLocaleString()}</WhatIfTableCell>
                </WhatIfTableRow>
                <WhatIfTableRow>
                  <WhatIfTableCell>% Difference in Emissions</WhatIfTableCell>
                  <WhatIfTableCell></WhatIfTableCell>
                  <WhatIfTableCell alignment={"center"}>{calculateNitrogenManufacturingEmissionsDifference().toLocaleString()+"%"}</WhatIfTableCell>
                  <WhatIfTableCell alignment={"center"}>{calculateTotalOrchardNitrogenEmissionsDifference().toLocaleString()+"%"}</WhatIfTableCell>
                </WhatIfTableRow>
              </TableBody>
            </FormTableWrapper>
          </Fieldset>
        </FormGroupWrapper>
      </PageSection>)}
       {(!isCalculating || isNullOrUndefined(calculatorData?.whatif?.changeToTotals)) &&  ( <PageSection>
        <Heading5>{WHAT_IF_EMISSIONS_GRAPH_HEADING_TEXT}</Heading5>
        <BarGraph
          hideDisclaimer={true}
          data={getGraphData()}
          colorScale={[theme.darkBlue, theme.brightGreen]}
          legendLabels={WHAT_IF_GRAPH_INFO.groups.map((group) => group.label)}
        />
      </PageSection>)}
      <ErrorModal error={error} onClose={() => setError(null)} />
      <LoadingModal isOpen={isCalculating} />
    </PageContainer>
  )
}
